import SalesOrderDocumentPage from "../../pages/legacy/SalesOrderDocumentPage";

const route = {
  key: "salesorder.detailNoDataArea",
  path: "/legacy/sales-orders/document/:id",
  component: SalesOrderDocumentPage,
  private: true,
  layout: "main",
  icon: "faFileInvoice",
  group: "sales",
  order: 21.02,
  permission: "legacy.salesorder.read"
};

export default route;